import {
  ACTION_BUTTON_TYPE_DELETE,
  ButtonAction,
  COLLAPSIBLE_TRIGGER_VARIANT_LIGHT,
  Collapsible,
  CollapsibleTrigger,
  DataListRow,
  Flex,
  Grid,
  GridCell,
  ModalConfirm,
  Panel,
  SKELETON_LOADER_VARIANT_ONWHITE,
  SPACING_8,
  SkeletonLoader,
  SpacingVertical,
  TEXT_VARIANT_LIGHT,
  TEXT_VARIANT_SMALL_LIGHT,
  Text,
} from 'mailup-web-components'
import PropTypes from 'prop-types'
import React, { useState } from 'react'

import { useIntl } from 'react-intl'
import { useParams } from 'react-router-dom'
import { useRecoilCallback, useRecoilValue, useSetRecoilState } from 'recoil'
import {
  deleteBouncesCallback,
  loadBounceTableCallback,
} from '../recoil/callbacks/callbacks'

import { modalDeleteState } from '../recoil/state/page'
import { tableStateResult, tableStateSerach } from '../recoil/state/result'

import BulkActionsMenu from '../BulkActionsMenu'
import Pagination from '../Pagination'
import ResultCheckbox from '../ResultCheckbox'
import SelectAll from '../SelectAll'

const Details = ({ children }) => {
  const intl = useIntl()
  const [collapsed, setCollapsed] = useState(true)

  const handleChange = () => {
    setCollapsed((prev) => !prev)
  }

  return (
    <>
      <CollapsibleTrigger
        collapsed={collapsed}
        onChange={handleChange}
        variant={COLLAPSIBLE_TRIGGER_VARIANT_LIGHT}
        data-mu-test="details-trigger"
      >
        {intl.formatMessage({
          id: 'Load.MailupCommon.MoreDetails',
        })}
      </CollapsibleTrigger>
      <Collapsible collapsed={collapsed} data-mu-test="details">
        {children}
      </Collapsible>
    </>
  )
}

Details.propTypes = {
  children: PropTypes.node,
}

const BounceTable = () => {
  const intl = useIntl()
  const { idRecipient } = useParams()
  const loadBounceTable = useRecoilCallback(loadBounceTableCallback, [])
  const deleteBounces = useRecoilCallback(deleteBouncesCallback, [])
  // const { orderBy, orderDescending } = useRecoilValue(tableStateSerach)
  const { pageSize } = useRecoilValue(tableStateSerach)
  const { loading, items } = useRecoilValue(tableStateResult)

  const modalDelete = useRecoilValue(modalDeleteState)
  const setModalDelete = useSetRecoilState(modalDeleteState)

  const closeModalDelete = () => {
    setModalDelete({ show: false })
  }

  const confirmDelete = async () => {
    await deleteBounces(idRecipient, modalDelete.items)
    loadBounceTable({ idRecipient })
  }

  const onClickDelete = async (item) => {
    setModalDelete({ show: true, items: [item] })
  }

  function getBounceName(bounceType) {
    switch (bounceType) {
      case 'HB':
        return intl.formatMessage({ id: 'Load.Bounce.HBText' })
      case 'SBMF':
        return intl.formatMessage({ id: 'Load.Bounce.SBMFText' })
      case 'SBDF':
        return intl.formatMessage({ id: 'Load.Bounce.SBDFText' })
      case 'MB':
        return intl.formatMessage({ id: 'Load.Bounce.MBText' })
      case 'MBKS':
        return intl.formatMessage({ id: 'Load.Bounce.MBKSText' })
      case 'MBSD':
        return intl.formatMessage({ id: 'Load.Bounce.MBSDText' })
      case 'MBRD':
        return intl.formatMessage({ id: 'Load.Bounce.MBRDText' })
      case 'TB':
        return intl.formatMessage({ id: 'Load.Bounce.TBText' })
      case 'SB':
        return intl.formatMessage({ id: 'Load.Bounce.SBText' })
      case 'GB':
        return intl.formatMessage({ id: 'Load.Bounce.GBText' })
      default:
        return '-'
    }
  }

  return (
    <>
      <ModalConfirm
        show={modalDelete.show}
        title={
          modalDelete.items && modalDelete.items.length > 1
            ? intl.formatMessage(
                { id: 'Load.RecipientBounce.ModalDeleteTitle' },
                {
                  X: modalDelete.items.length,
                },
              )
            : intl.formatMessage({
                id: 'Load.RecipientBounce.ModalDeleteTitleOneError',
              })
        }
        message={
          modalDelete.items && modalDelete.items.length > 1
            ? intl.formatMessage({
                id: 'Load.RecipientBounce.ModalDeleteDescr',
              })
            : intl.formatMessage({
                id: 'Load.RecipientBounce.ModalDeleteDescrOneError',
              })
        }
        stringConfirm={intl.formatMessage({ id: 'Load.MailupCommon.Delete' })}
        stringCancel={intl.formatMessage({ id: 'Load.MailupCommon.Cancel' })}
        onClickCancel={closeModalDelete}
        onClickConfirm={confirmDelete}
        variant="delete"
      />
      <Panel margin="0 0 80px 0">
        <SelectAll />
        <section>
          {loading &&
            Array.from({ length: Math.max(5, pageSize) }).map((_, idx) => (
              <DataListRow key={idx}>
                <Grid cols={12}>
                  <GridCell span={3}>
                    <SkeletonLoader variant={SKELETON_LOADER_VARIANT_ONWHITE} />
                  </GridCell>
                  <GridCell span={6}>
                    <SkeletonLoader
                      variant={SKELETON_LOADER_VARIANT_ONWHITE}
                      height={'16px'}
                    />
                    <SkeletonLoader
                      variant={SKELETON_LOADER_VARIANT_ONWHITE}
                      height="15px"
                    />
                  </GridCell>
                  <GridCell span={2}>
                    <SkeletonLoader variant={SKELETON_LOADER_VARIANT_ONWHITE} />
                  </GridCell>
                  <GridCell span={1}>
                    <ButtonAction
                      type={ACTION_BUTTON_TYPE_DELETE}
                      disabled
                      data-mu-test="delete-bouce"
                      onClick={() => {}}
                    />
                  </GridCell>
                </Grid>
              </DataListRow>
            ))}

          {!loading && (
            <>
              {items.map((item, key) => (
                <DataListRow key={key} data-mu-test="list-data_row">
                  <Grid cols={12}>
                    <GridCell span={3} data-mu-test="item-check">
                      <Flex flexDirection="column" gap="8px">
                        <ResultCheckbox
                          label={item.BounceType}
                          id={item.FakeId}
                        />
                        <Flex margin="0 0 0 27px">
                          <Text variant={TEXT_VARIANT_SMALL_LIGHT}>
                            {getBounceName(item.BounceType)}
                          </Text>
                        </Flex>
                      </Flex>
                    </GridCell>
                    <GridCell span={6} data-mu-test="item-subject">
                      <Text variant={TEXT_VARIANT_LIGHT}>{item.Subject}</Text>
                      <SpacingVertical variant={SPACING_8} />
                      {item.RawMsg && <Details>{item.RawMsg}</Details>}
                    </GridCell>
                    <GridCell span={2} data-mu-test="item-date">
                      <Text variant={TEXT_VARIANT_LIGHT}>{item.EventDate}</Text>
                    </GridCell>
                    <GridCell span={1}>
                      <Flex justifyContent="flex-end">
                        <ButtonAction
                          type={ACTION_BUTTON_TYPE_DELETE}
                          data-mu-test="delete-bouce"
                          onClick={() => onClickDelete(item.FakeId)}
                        />
                      </Flex>
                    </GridCell>
                  </Grid>
                </DataListRow>
              ))}
            </>
          )}
        </section>
        <Pagination />
      </Panel>

      <BulkActionsMenu />
    </>
  )
}

export default BounceTable
